import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import z from 'zod';

import type { CreateAsnDTO } from '@invenco/supply-interface';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/core/card';
import { Form } from '@/components/core/form';
import { DatePickerFormField } from '@/components/forms/date-picker-form-field';
import { WizardStep } from '@/components/wizard';
import type { WizardStepDefinition } from '@/components/wizard/wizard-context';
import { useIsFormValid } from '@/shared/hooks/use-is-form-valid';

const expectedDateSchema = z.object({
  expectedAt: z.date('Enter an expected date'),
});

export function ExpectedDateStep({
  step,
  onChange,
}: {
  step: WizardStepDefinition;
  onChange: (input: Partial<CreateAsnDTO>) => void;
}) {
  const form = useForm({
    resolver: zodResolver(expectedDateSchema),
  });
  const isValid = useIsFormValid(form, expectedDateSchema);

  const submitSection = async () => {
    let valid = false;

    await form.handleSubmit(({ expectedAt }) => {
      onChange({ expectedAt: expectedAt.toISOString() });
      valid = true;
    })();

    return valid;
  };

  return (
    <WizardStep step={step} complete={isValid} onSubmitStep={submitSection}>
      <Card aria-label="Expected date">
        <CardHeader>
          <CardTitle>Expected date</CardTitle>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <DatePickerFormField
              control={form.control}
              name="expectedAt"
              aria-label="Expected date"
              placeholder="Select date"
              description="Set the expected date that the shipment is expected to arrive at the warehouse."
            />
          </Form>
        </CardContent>
      </Card>
    </WizardStep>
  );
}
